import { lazy } from 'react';

export const LazyAdmin = lazy(() => import('@/pages/Admin'));
